/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

var DEFAULT_Z_INDEX = 6e3;
var DISTANCE = "16px";
var PLACEMENT_OFFSET = {
  "top-left": {
    left: DISTANCE,
    top: DISTANCE
  },
  "top-right": {
    right: DISTANCE,
    top: DISTANCE
  },
  "bottom-right": {
    right: DISTANCE,
    bottom: DISTANCE
  },
  "bottom-left": {
    left: DISTANCE,
    bottom: DISTANCE
  }
};
var PLACEMENT_LIST = Object.keys(PLACEMENT_OFFSET);

export { DEFAULT_Z_INDEX, DISTANCE, PLACEMENT_LIST, PLACEMENT_OFFSET };
//# sourceMappingURL=const.js.map
